import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import { ChipClickable } from '../../../Chips';
import { startApplyBidTemplate } from '../../../../store/actions/bidTemplates';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
});

//TODO: add template types to constants, also make constants a module for
// easier importing
const Templates = ({ classes, bid, startApplyBidTemplate }) => {
  return(
    <div className={classes.root}>
      <ChipClickable
        label="Maintenance"
        handleClick={() => {
          startApplyBidTemplate(bid.id, "maintenance")
        }}/>
      <ChipClickable
        label="Big Project"
        handleClick={() => {
          startApplyBidTemplate(bid.id, "quote")
        }}/>
      <ChipClickable
        label="Quickie"
        handleClick={() => {
          startApplyBidTemplate(bid.id, "estimate")
        }}/>
    </div>
  );
};

const mapStateToProps = (state) => {
  const bidId = state.adminState.bid.id;

  return({
    bid: state.bidsState.find( bid => bid.id === bidId ),
  });
};

const mapDispatchToProps = (dispatch) => ({
  startApplyBidTemplate: (bidId, type) => dispatch(startApplyBidTemplate(bidId, type)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Templates);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Header/Templates.jsx